import { getFartherEndingPath } from 'sweet-graphs';
import { getCurrentProgressPath } from './get-current-progress-path';
import { calculatePercentComplete, subtractFromSet, } from './calculate-percent-complete';
export function extractSequentialTaskProgressInfo(nodeMap, taskProgress) {
    var _a;
    var _b = getCurrentProgressPath(nodeMap, taskProgress), completedPath = _b[0], activeNode = _b[1];
    // these are the default values for infinite loops
    var farthestEndingDistance = Infinity;
    var nodesAhead = new Set();
    var farthestEndingPath = null;
    // currentNode will be null on never-ending loop structures
    if (activeNode != null) {
        _a = getFartherEndingPath(activeNode, nodeMap), farthestEndingDistance = _a[0], nodesAhead = _a[1], farthestEndingPath = _a[2];
        nodesAhead.delete(activeNode);
    }
    // on maps with loops, the futureNodes can contain already visited nodes
    // let's remove them (see infiniteLoopGuyProgresses as example)
    nodesAhead = subtractFromSet(nodesAhead, completedPath);
    return {
        isSequenced: true,
        completedPath: completedPath,
        farthestEndingDistance: farthestEndingDistance,
        percentComplete: calculatePercentComplete(completedPath.length, farthestEndingDistance),
        activeNodes: new Set(activeNode != null ? [activeNode] : []),
        nodesAhead: nodesAhead,
        canBeCompleted: farthestEndingDistance === 0 || activeNode == null,
        farthestEndingPath: farthestEndingPath,
    };
}
